import { PolicyConfigDecisionAttributeFieldResultTypes } from "@enums/policy-config-decision-attribute-field-result-type";
import { SelectOption } from "@idw-types/common";

export const POLICY_CONFIG_DECISION_ATTRIBUTE_FIELD_RESULT_OPTIONS: Array<SelectOption> = [
    { label: "MATCHES", value: PolicyConfigDecisionAttributeFieldResultTypes.MATCHES },
    { label: "DOES NOT MATCH", value: PolicyConfigDecisionAttributeFieldResultTypes.DOES_NOT_MATCH },
    { label: "GREATER THAN", value: PolicyConfigDecisionAttributeFieldResultTypes.GREATER_THAN },
    { label: "EQUAL TO", value: PolicyConfigDecisionAttributeFieldResultTypes.EQUAL_TO },
    { label: "LESS THAN", value: PolicyConfigDecisionAttributeFieldResultTypes.LESS_THAN }
];